import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ITravelWire, CodeStatus, ITravelPassengerRange } from 'app/travel/travel.interfaces';
import { FormGroup, FormBuilder, FormControl, FormArray, AbstractControl } from '@angular/forms';
import { ChildrenAges } from 'app/travel/travel.models';
import { startWith } from 'rxjs/operators'
import { SelectItem } from 'app/shared/select-field/select.model';
import { strEqualIgnoreCase } from 'app/shared/utils';
import { ResourceService } from 'app/shared/resources/resource.service';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'sbw-travel-passengers',
    templateUrl: './travel-passengers.component.html',
    styleUrls: ['./travel-passengers.component.css']
})
export class TravelPassengersComponent implements OnInit {

    private _showPets = false
    public childrenSelected: Array<number> = []
    public childrenAgeRange: any[]
    public mobileViewport: boolean

    constructor(private resourceService: ResourceService) { this.attachMediaQueryHandler() }

    get adultCount() { return this.passengerSelections.get('adultCount') }
    get petCount() { return this.passengerSelections.get('petCount') }
    get childCount() { return this.passengerSelections.get('childCount') }
    get childrenAgeArray(): FormArray { return this.passengerSelections.get('childrenAges') as FormArray }

    @Input() giveAttentionChildAges = false
    @Input() passengerRanges: ITravelPassengerRange;
    @Input() passengerSelections: FormGroup;
    @Input() set showPets(value: boolean) {
        this._showPets = value
        this.resetPets()
    }
    get showPets(): boolean {
        return this._showPets
    }

    get adultRange(): SelectItem[] {
        return this.passengerRanges.adultPassengerRange.map(n => <SelectItem>{ value: n, text: n.toString() });
    }

    get childRange(): SelectItem[] {
        return this.passengerRanges.childPassengerRange.map(n => <SelectItem>{ value: n, text: n.toString() });
    }

    get childAgeRange(): SelectItem[] {
        return this.childrenAgeRange.map(n => <SelectItem>{ value: n.value, text: n.description })
    }

    get petRange(): SelectItem[] {
        return this.passengerRanges.petPassengerRange.map(n => <SelectItem>{ value: n, text: n.toString() })
    }

    get hasInfants(): boolean { return this.ageModel().infants > 0 }
    callAttentionChildAges(i: number) { return this.giveAttentionChildAges && this.childrenAgeArray.controls[i].value == '' }
    private ageModel() { return ChildrenAges.fromStrings(this.childrenAgeArray.value, this.childCount.value) }

    ngOnInit() {
        // Set array 0-15 as child age range
        this.setChildrenRange();
        this.onChildCountChanged()
    }

    private attachMediaQueryHandler() {
        if (window.matchMedia) {
            const mqMobile = window.matchMedia('(max-width: 40em)')
            this.mobileViewport = mqMobile.matches
            mqMobile.addListener(mq => this.mobileViewport = mq.matches)
        }
    }

    private resetPets() {
        if (!this._showPets) {
            this.petCount.setValue(0)
        }
    }

    private setChildrenRange() {
        this.childrenAgeRange = [{ value: "", description: "-" }]
            .concat(Array(16).fill(0).map((x, i) => ({ value: i.toString(), description: i.toString() })))
    }

    private onChildCountChanged() {
        this.childCount.valueChanges.pipe(
            startWith(this.childCount.value))
            .subscribe(v => this.childrenSelected = new Array(parseInt(v)).fill(0).map((_, i) => i))
    }

    // Function that childAges selectField uses to determine which select field should have the correct children label, and which should be empty.
    // To solve the non-breaking-space issue, we gave it _ which will be replaced later by the $sbnp;
    getLabel(index) {
        switch (index) {
            case 0: return this.resourceService.get('CHILDREN_AGES')
            case 1: return of('_')
            case 2: return this.mobileViewport ? null : of('_')
            default: return null
        }
    }

}
